import { css, Interpolation, Theme } from '@emotion/react'

export const editor: Interpolation<Theme> = css`
  .ck-content {
    font-family: 'Open Sans', Helvetica, sans-serif;
  }
`
